import { Array, Number, Record, Static, String } from "runtypes";

export const SeasonResponseRuntype = Record({
  id: Number,
  name: String,
  order: Number,
  schoolId: Number,
  sportIds: Array(Number),
  startDate: Number,
});

export interface ISeasonResponse extends Static<typeof SeasonResponseRuntype> {}

export interface ISeasonResponsesAndSchoolActive {
  seasons: ISeasonResponse[];
  schoolSeasonActive?: true;
}



// WEBPACK FOOTER //
// ./src/services/ISeasonResponse.ts